import Link from "next/link";
import ShButton from "../../components/button/shButton";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../provider/authProvider";

import styles from './shMenu.module.scss';

import BrandIcon from 'public/logo/brand-icon.svg';
import BrandWordmarkDark from 'public/logo/brand-wordmark-dark.svg';
import BrandWordmarkLight from 'public/logo/brand-wordmark-light.svg';

import AccountIcon from 'public/icons/account.svg';
import ChevronDownSVG from 'public/icons/chevronDown.svg';

import BookmarkOutlineSVG from 'public/icons/bookmarkOutline.svg';
import BookSVG from 'public/icons/book.svg';
import AccountSVG from 'public/icons/account.svg';
import GiftSVG from 'public/icons/gift.svg';
import LogoutSVG from 'public/icons/logout.svg';
import DiscountSVG from 'public/icons/discount.svg';
import SearchSVG from 'public/icons/search.svg';

import { useRouter } from "next/router";
import useAboOwn from "../../custom-hooks/useAboOwn";

const ShMenu = (
    {
        style = 'light',
        className = '',
    }
) => {

    const [ showMoreLeftMenu, setShowMoreLeftMenu ] = useState(false);
    const [ showAccountMenu, setShowAccountMenu ] = useState(false);

    const authContext = useContext(AuthContext);

    const aboOwn = useAboOwn();

    const hideAll = () => {
        setShowAccountMenu(false);
        setShowMoreLeftMenu(false);
    }

    const router = useRouter();
    useEffect( () => {
        const routeHandler = () => {
            hideAll();
        };

        router.events.on('routeChangeStart', routeHandler);

        return () => {
            router.events.off('routeChangeStart', routeHandler);
        }
    }, []);

    useEffect(
        () => {

            // check if SSR
            if (!window) {
                return;
            }

            const clickHandler = (event) => {
                // for chrome and other browsers
                if (event.path) {
                    for (const p of event?.path) {
                        if (p.id === 'menu') {
                            return;
                        }
                    }

                    setShowMoreLeftMenu(false);
                    setShowAccountMenu(false);
                } else {
                    // support for safari?
                }
            }

            window.addEventListener('click', clickHandler);

            return () => {
                window.removeEventListener('click', clickHandler);
            }
        }, []
    );




    // @refresh reset
    return (
        <div className={ "px-2 px-lg-3 py-2 py-md-4 py-xl-5 " +
                    className + " "  +
                    styles.menu + " " +
                    (style === 'dark' ? styles.dark : "") }
                    id="menu" >

            <div className={styles.menuMain + " h-100"}>

                <div className={styles.brandwordMark}>
                    <Link
                        href="/"
                        className="mr-0 mr-sm-3 mr-xl-5 align-self-center"
                        legacyBehavior>
                        { style === 'dark' ? <BrandWordmarkDark/> : <BrandWordmarkLight/>}
                    </Link>
                </div>

                <ul className={"h-100"}>
                    <li className="no-select d-flex align-items-center">
                        <Link href={aboOwn ? "/profil/kurse" : "/kochkurse"} passHref={true}>
                            Kochkurse
                        </Link>
                    </li>

                    {aboOwn
                        ?
                        <li className={"no-select d-flex d-sm-none d-lg-flex align-items-center"}>
                            <Link href="/rezepte" passHref={true}>
                                Rezepte
                            </Link>
                        </li>

                        :

                        <li className={"no-select d-flex d-sm-none d-lg-flex align-items-center"}>
                            <Link href="/gutscheine" passHref={true}>
                                Gutscheine
                            </Link>
                        </li>
                    }

                    <li className="no-select p-relative d-flex align-items-center"
                        onClick={ (e) => { setShowMoreLeftMenu(!showMoreLeftMenu); setShowAccountMenu(false); } }>
                        <a>Mehr</a>
                        <ChevronDownSVG className={"ml-1 svg-24 " + ( style !== 'dark' && "svg-light")} />

                        {showMoreLeftMenu &&
                            <div className={styles.submenu + " " + styles.submenuRight}>
                                <ul>

                                    {aboOwn ?
                                        <>
                                            <Link href="/rezepte" passHref={true} legacyBehavior>
                                                <li className={(router.pathname === '/rezepte' ? styles.active : '') + " d-block d-lg-none" }>
                                                    Rezepte
                                                </li>
                                            </Link>
                                            <Link href="/gutscheine" passHref={true} legacyBehavior>
                                                <li className={router.pathname === '/gutscheine' ? styles.active : ''}>
                                                    Gutscheine
                                                </li>
                                            </Link>
                                        </>
                                        :
                                        <>
                                            <Link href="/gutscheine" passHref={true} legacyBehavior>
                                                <li className={(router.pathname === '/gutscheine' ? styles.active : '') + " d-block d-lg-none"}>
                                                    Gutscheine
                                                </li>
                                            </Link>

                                            <Link href="/rezepte" passHref={true} legacyBehavior>
                                                <li className={router.pathname === '/rezepte' ? styles.active : ''}>
                                                    Rezepte
                                                </li>
                                            </Link>
                                        </>
                                    }

                                    <Link href="/experten" passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/experten' ? styles.active : ''}>
                                            Experten
                                        </li>
                                    </Link>

                                    <Link href="/preise" passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/preise' ? styles.active : ''}>
                                            Preise
                                        </li>
                                    </Link>

                                    <Link href="/blog" passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/blog' ? styles.active : ''}>
                                            Blog
                                        </li>
                                    </Link>

                                    <Link href="/faq" passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/faq' ? styles.active : ''}>
                                            Fragen & Antworten
                                        </li>
                                    </Link>
                                </ul>
                            </div>
                        }

                    </li>

                </ul>

            </div>

            <div className={styles.menuBetween}>
                <Link href="/">

                    <BrandIcon/>

                </Link>
            </div>

            <div className={(router.pathname === '/suche') ? "d-none" : ( styles.searchIcon + " c-pointer")}>
                <Link href="/suche" className={"d-flex align-items-center"}>

                    <SearchSVG className={(style === "light" && "svg-light") + "svg-32 mr-3 mr-lg-4"}/>

                </Link>
            </div>

            <div className={(style === "light" ? "text-white " : "text-dark ") + styles.toggleMobile + " no-select"} onClick={ () => { authContext.setShowMobileOverlay(true); } }>
                Menü
            </div>

            {authContext?.isLoggedIn &&
                <div className={styles.menuProfile}
                     onClick={(e) => { setShowAccountMenu(!showAccountMenu); setShowMoreLeftMenu(false); } }>


                    <div className="p-relative">
                        <ShButton className="p-relative" variant={'solid-dark'} size={'small'}>
                            <AccountIcon className="svg-light svg-24"/>
                            Mein Profil
                        </ShButton>

                        {showAccountMenu &&
                            <div className={styles.submenu + " " + styles.submenuRight}>
                                <ul>

                                    <Link href={"/profil/kurse"} passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/profil/kurse' ? styles.active : ''}>
                                            <a className={"d-flex align-items-center"}>
                                                <BookmarkOutlineSVG className={"svg-light svg-24"} />
                                                Meine Kurse
                                            </a>
                                        </li>
                                    </Link>


                                    <Link href={"/profil/rezepte"} passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/profil/rezepte' ? styles.active : ''}>
                                            <a className={"d-flex align-items-center"}>
                                                <BookSVG className={"svg-light svg-24"}/>
                                                Meine Rezepte
                                            </a>
                                        </li>
                                    </Link>

                                    <Link href={"/profil/gutscheine"} passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/profil/gutscheine' ? styles.active : ''}>
                                            <a className={"d-flex align-items-center"}>
                                                <GiftSVG className={"svg-light svg-24"} />
                                                Meine Gutscheine
                                            </a>
                                        </li>
                                    </Link>

                                    <Link href={"/profil/mein-account"} passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/profil/mein-account' ? styles.active : ''}>
                                            <a className={"d-flex align-items-center"}>
                                                <AccountSVG className={"svg-light svg-24"} />
                                                Mein Account
                                            </a>
                                        </li>
                                    </Link>

                                    {/*<Link href={"/profil/rechnungen"} passHref={true} className={isInternal && "d-none"}>
                                <li className={router.pathname === '/profil/rechnungen' ? styles.active : ''}>
                                    <a className={"d-flex align-items-center"}>
                                        <InvoiceSVG className={"svg-light svg-24"} />
                                        Rechnungen
                                    </a>
                                </li>
                            </Link>*/}

                                    <Link href={"/profil/vorteile"} passHref={true} legacyBehavior>
                                        <li className={router.pathname === '/profil/vorteile' ? styles.active : ''}>
                                            <a className={"d-flex align-items-center"}>
                                                <DiscountSVG className={"svg-light svg-24"}/>
                                                Meine Vorteile
                                            </a>
                                        </li>
                                    </Link>


                                    <li onClick={ () => { authContext.logout(); hideAll(); } }>
                                        <a className={"d-flex align-items-center"} >
                                            <LogoutSVG className={"svg-light svg-24"}/>
                                            Logout
                                        </a>
                                    </li>


                                </ul>
                            </div>
                        }
                    </div>
                </div>
            }

            {!authContext.isLoggedIn &&
                <div className={styles.menuProfile}>

                    <ShButton variant="solid-dark" size={"small"}
                              onClick={() => authContext.handleLogin(true)}>
                        <AccountIcon className={"svg-light svg-24"}/>
                        Login
                    </ShButton>
                </div>
            }


        </div>
    );

};

export default ShMenu;
